import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import WidgetsGrid from '../components/_layout/WidgetsGrid';
import Page from '../components/_layout/Page';
import useNavProject from '../hooks/useNavProject';
import useAPI from '../hooks/useAPI';
import { useProjectForNav } from '../hooks/useProjectForNav';
import { hasPermsOnIndexesOrReceipts } from '../services/rolesSvc';
import useUserContext from '../hooks/useUserContext';
import {BaseRequests} from '../requests/BaseRequests';
import { getPathType } from '../helpers/typeProject';

const defaultYear = Number(DEFAULT_YEAR_WEBPACK_REPORT)
function PortfolioProjectWidgets() {
  const {
    stratId, portfolioId, projId, reportYear,
  } = useParams();

  const navProject = useNavProject();
  const api = useAPI();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const proj = useProjectForNav(api, navProject, projId);
  const userCtx = useUserContext();
  const [strategyObject, setStrategyObject] = useState('strats');

  const routes = useMemo(() => [
    { name: 'Отчет', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/yearReport/year/${reportYear ?? defaultYear}` },
    { name: 'Статьи', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/articles` },
    { name: 'Доходы (не действует с 2023 года)', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/income`, inactive: true },
    { name: 'Заявки', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/requests` },
    { name: 'Унифицированные показатели проекта', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/unified`, show: () => hasPermsOnIndexesOrReceipts(userCtx, { stratId, portfolioId, projId }) },
    { name: 'Вехи проекта', url: !!stratId ? `/${strategyObject}/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}` : `/projs/${projId}`}/report/milestones` : `/policies/${policyId}/projs/${projId}/report/milestones` },
    { name: 'Поступления от научной и иновационной деятельности', url: `/${strategyObject}/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/receipts` },
  ], [stratId, portfolioId, projId, reportYear, userCtx, strategyObject]);

  useEffect(async () => {
    const respProject = await api.get(`/structure/projs/${projId}`);
    if (!respProject || respProject.error) return;
    if(respProject.strategy?.type !== 'strategy'){
      setStrategyObject(getPathType(respProject.strategy?.type))
    }
    BaseRequests.getNavigationLinks(respProject,navProject)
  }, []);

  return (
    <Page header="Отчет по проекту" className="policies-page">
      <WidgetsGrid items={routes.filter((w) => !w.show || w.show(userCtx.perms))} />
    </Page>
  );
}

export default PortfolioProjectWidgets;
